import { colors, TableCell, TableRow } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TableRowStyled = styled(TableRow)`
  border-bottom: 1px solid ${colors.neutral[300]};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const TableCellStyled = styled(TableCell)`
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${colors.neutral[900]};
  letter-spacing: 0.02rem;
  padding: 1.6rem 1rem 1.6rem 0;

  &:first-child {
    padding-left: 2.4rem;
  }
`;

export const ActionCellStyled = styled(TableCellStyled)`
  text-align: right;
`;

export const GroupNumberStyled = styled.span`
  color: ${colors.neutral[600]};
`;
